// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected-combination_rowGrid__vnZI- {
    display: grid;
    grid-template-columns: 25px 1fr;
}

.selected-combination_selectableItem__8lRE2 {
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
    margin-bottom: 6px;
    padding: 0;
    border-bottom: 1px solid transparent;
    border-radius: 0;
    transition:
        border-color 0.4s,
        color 0.4s,
        font-weight 0.4s;
    text-align: left;
    display: block;
}

.selected-combination_selectableItem__8lRE2.selected-combination_selected__CIS3k {
    font-weight: 700;
    color: #1650b4;
    border-color: #1650b4;
}

.selected-combination_block__nOUd2 {
    /*font-size: 16px;*/
    /*font-weight: 300;*/
    margin-left: 35px;
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
}

.selected-combination_label__DVemT {
    display: grid;
    /*margin-bottom: 10px;*/
    /*text-transform: capitalize;*/
    /*min-height: 45px;*/
    margin-bottom: 6px;
    grid-gap: 10px;
    grid-template-columns: 25px auto;

    /*--checkbox-font-size: 16px;*/
    --checkbox-font-size: inherit;
    --checkbox-bg-color: var(--primary-color);

    --icon-color-outer-custom: var(--primary-color-active);
    color: var(--dark-grey);
}

.selected-combination_label__DVemT > span,
.selected-combination_label__DVemT > span svg {
    height: 25px;
}

.selected-combination_alignTop__FwJIR {
    align-items: flex-start;
}

.selected-combination_alignMiddle__zPFsa {
    align-items: center;
}

.selected-combination_label__DVemT h6 {
    font-size: 14px;
    font-weight: 400;
}
@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .selected-combination_label__DVemT h6 {
        /*margin-bottom: 10px;*/
        /*min-height: 16px;*/
        /*font-weight: 400;*/
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
    }
}

.selected-combination_highlight__tt\\+dx {
    color: var(--secondary-color);
    text-transform: capitalize;
    font-size: 16px;
    /*margin: auto 0 !important;*/
}

.selected-combination_label__DVemT span {
    font-weight: 300;
    min-height: 16px;
    display: inline-block;
}

.selected-combination_labelMargin__J\\+bUR {
    margin-bottom: 16px;
}

.selected-combination_labelMarginLast__bX2CI {
    margin-bottom: 30px;
}

.selected-combination_labelImg__1dvyB {
    margin-right: 10px;
    opacity: 0.5;
}

.selected-combination_labelSm__90TXL span {
    font-weight: 300;
    margin-left: 30px;
}

.selected-combination_labelSm__90TXL:not(:last-child) {
    margin-bottom: 5px;
}

.selected-combination_proposedCheck__po8Mn {
    display: flex;
    justify-content: space-between;
    /*margin-bottom: 6px;*/
    /*padding-left: 50px;*/
    /*width: 200px;*/
}
.selected-combination_proposedWrapper__wOplm {
    margin-top: 12px;

    /*    margin-top: -30px;*/
}

.selected-combination_proposedWrapper__wOplm.selected-combination_pdf__yGxNe {
    /*margin-top: -20px;*/
}

/*.proposedWrapper.pdf .proposedCheck {*/
/*    padding-left: 0;*/
/*}*/

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    /*.label h6 {*/
    /*    font-size: 16px;*/
    /*}*/

    /*.block {*/
    /*    --checkbox-font-size: 16px;*/
    /*}*/
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .selected-combination_rowGrid__vnZI- {
        grid-template-columns: 20px 1fr;
    }

    .selected-combination_block__nOUd2 {
        font-size: 14px;
        margin-left: 30px;
        grid-gap: 6px;
    }

    .selected-combination_label__DVemT {
        grid-template-columns: 20px auto;
    }

    .selected-combination_label__DVemT > span,
    .selected-combination_label__DVemT > span svg {
        height: 20px;
    }

    .selected-combination_label__DVemT h6 {
        /*font-size: 9px;*/
        /*margin-bottom: 6px;*/
        color: var(--dark-grey);
        font-weight: bold;
    }

    .selected-combination_labelMargin__J\\+bUR {
        margin-bottom: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectedCombination/selected-combination.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,oCAAoC;IACpC,gBAAgB;IAChB;;;wBAGoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,gCAAgC;;IAEhC,8BAA8B;IAC9B,6BAA6B;IAC7B,yCAAyC;;IAEzC,sDAAsD;IACtD,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;QACI,uBAAuB;QACvB,oBAAoB;QACpB,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,yBAAyB;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,gBAAgB;;IAEhB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,wCAAwC;AACxC,uBAAuB;AACvB,IAAI;;AAEJ;IACI,cAAc;IACd,uBAAuB;IACvB,IAAI;;IAEJ,WAAW;IACX,kCAAkC;IAClC,IAAI;AACR;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["@value screen-md-max, screen-lg-min from '../../breakpoints.css';\n\n.rowGrid {\n    display: grid;\n    grid-template-columns: 25px 1fr;\n}\n\n.selectableItem {\n    font-size: inherit;\n    color: inherit;\n    font-weight: inherit;\n    margin-bottom: 6px;\n    padding: 0;\n    border-bottom: 1px solid transparent;\n    border-radius: 0;\n    transition:\n        border-color 0.4s,\n        color 0.4s,\n        font-weight 0.4s;\n    text-align: left;\n    display: block;\n}\n\n.selectableItem.selected {\n    font-weight: 700;\n    color: #1650b4;\n    border-color: #1650b4;\n}\n\n.block {\n    /*font-size: 16px;*/\n    /*font-weight: 300;*/\n    margin-left: 35px;\n    display: flex;\n    flex-direction: column;\n    grid-gap: 10px;\n}\n\n.label {\n    display: grid;\n    /*margin-bottom: 10px;*/\n    /*text-transform: capitalize;*/\n    /*min-height: 45px;*/\n    margin-bottom: 6px;\n    grid-gap: 10px;\n    grid-template-columns: 25px auto;\n\n    /*--checkbox-font-size: 16px;*/\n    --checkbox-font-size: inherit;\n    --checkbox-bg-color: var(--primary-color);\n\n    --icon-color-outer-custom: var(--primary-color-active);\n    color: var(--dark-grey);\n}\n\n.label > span,\n.label > span svg {\n    height: 25px;\n}\n\n.alignTop {\n    align-items: flex-start;\n}\n\n.alignMiddle {\n    align-items: center;\n}\n\n.label h6 {\n    font-size: 14px;\n    font-weight: 400;\n}\n@media screen-lg-min {\n    .label h6 {\n        /*margin-bottom: 10px;*/\n        /*min-height: 16px;*/\n        /*font-weight: 400;*/\n        font-size: 12px;\n        font-weight: 600;\n        text-transform: uppercase;\n    }\n}\n\n.highlight {\n    color: var(--secondary-color);\n    text-transform: capitalize;\n    font-size: 16px;\n    /*margin: auto 0 !important;*/\n}\n\n.label span {\n    font-weight: 300;\n    min-height: 16px;\n    display: inline-block;\n}\n\n.labelMargin {\n    margin-bottom: 16px;\n}\n\n.labelMarginLast {\n    margin-bottom: 30px;\n}\n\n.labelImg {\n    margin-right: 10px;\n    opacity: 0.5;\n}\n\n.labelSm span {\n    font-weight: 300;\n    margin-left: 30px;\n}\n\n.labelSm:not(:last-child) {\n    margin-bottom: 5px;\n}\n\n.proposedCheck {\n    display: flex;\n    justify-content: space-between;\n    /*margin-bottom: 6px;*/\n    /*padding-left: 50px;*/\n    /*width: 200px;*/\n}\n.proposedWrapper {\n    margin-top: 12px;\n\n    /*    margin-top: -30px;*/\n}\n\n.proposedWrapper.pdf {\n    /*margin-top: -20px;*/\n}\n\n/*.proposedWrapper.pdf .proposedCheck {*/\n/*    padding-left: 0;*/\n/*}*/\n\n@media screen-lg-min {\n    /*.label h6 {*/\n    /*    font-size: 16px;*/\n    /*}*/\n\n    /*.block {*/\n    /*    --checkbox-font-size: 16px;*/\n    /*}*/\n}\n\n@media screen-md-max {\n    .rowGrid {\n        grid-template-columns: 20px 1fr;\n    }\n\n    .block {\n        font-size: 14px;\n        margin-left: 30px;\n        grid-gap: 6px;\n    }\n\n    .label {\n        grid-template-columns: 20px auto;\n    }\n\n    .label > span,\n    .label > span svg {\n        height: 20px;\n    }\n\n    .label h6 {\n        /*font-size: 9px;*/\n        /*margin-bottom: 6px;*/\n        color: var(--dark-grey);\n        font-weight: bold;\n    }\n\n    .labelMargin {\n        margin-bottom: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"rowGrid": `selected-combination_rowGrid__vnZI-`,
	"selectableItem": `selected-combination_selectableItem__8lRE2`,
	"selected": `selected-combination_selected__CIS3k`,
	"block": `selected-combination_block__nOUd2`,
	"label": `selected-combination_label__DVemT`,
	"alignTop": `selected-combination_alignTop__FwJIR`,
	"alignMiddle": `selected-combination_alignMiddle__zPFsa`,
	"highlight": `selected-combination_highlight__tt+dx`,
	"labelMargin": `selected-combination_labelMargin__J+bUR`,
	"labelMarginLast": `selected-combination_labelMarginLast__bX2CI`,
	"labelImg": `selected-combination_labelImg__1dvyB`,
	"labelSm": `selected-combination_labelSm__90TXL`,
	"proposedCheck": `selected-combination_proposedCheck__po8Mn`,
	"proposedWrapper": `selected-combination_proposedWrapper__wOplm`,
	"pdf": `selected-combination_pdf__yGxNe`
};
export default ___CSS_LOADER_EXPORT___;
